import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import IconArrow from "../../assets/images/icon-arrow-3.svg"

const Container = styled.div`
    width: 100%;

    .label {
        color: #2A2A2A;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
        margin-bottom: 8px;
    }

    .label-error {
        height: 16px;
        color: #F84242;
        font-size: 14px;
        font-weight: 300;
        margin-top: 4px;
    }
`;

const DropdownBox = styled.div`
    width: 100%;
    height: 40px;
    position: relative;
    background-color: #F5F5F5;
    border-radius: 30px;
    transition: all 0.2s ease;

    .dropdown-content {
        width: calc(100% - 32px);
        height: 100%;
        padding: 0px 16px;
        cursor: pointer;

        &.disabled {
            cursor: default;
            background-color: #B3B3B333;
        }
    }

    &.error {
        border: 1px solid #F84242 !important;
    }

    &.open {
        /* border: 1px solid #FBE250; */
    }

    .label-placeholder {
        color: #838BB4;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: left;
    }

    .label-name {
        width: calc(100% - 24px);
        color: #25368D;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
    }

    .image-arrow-box {
        width: 24px;
        height: 24px;
        margin-left: auto;
        margin-right: 0px;
        border-radius: 50%;
        padding-top: 2px;
        transition: all 0.3s ease;

        .image-arrow {
            transition: all 0.3s ease;

            &.open {
                transform: rotateX(180deg);
            }
        }
    }
`;

const DropdownItemBox = styled.div`
    width: calc(100% - 16px);
    max-height: 200px;
    overflow-y: auto;
    padding: 8px;
    position: absolute;
    top: -120px;
    right: 0px;
    z-index: 9;
    border: 1px solid #B5B5B533;
    background-color: #FFFFFF;
    box-shadow: 0px 4px 4px 0px #60606012;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 2px;

    .box-top {
        
    }

    .menu-multi {
        height: 48px;
        min-height: 48px;
        padding: 0px 8px;
        color: #505050;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: left;
        border-radius: 10px;
        cursor: pointer;
        transition: all 0.3s ease;

        &.active {
            color: #25368D;
        }

        .box {
            width: 16px;
            height: 16px;
            min-width: 16px;
            margin-left: 1px;
            margin-right: 12px;
            border-radius: 2px;
            border: 1px solid #505050;

            &.active {
                background-color:  #FBE250;
                border: 1px solid #FBE250;
            }
        }
    }

    .menu-single {
        height: 48px;
        min-height: 48px;
        padding: 0px 8px;
        color: #505050;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: left;
        border-radius: 10px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
            background-color: #FBE25099;
        }

        &.active {
            color: #25368D;
            background-color: #FBE250;
        }
    }

    .nodata {
        height: 48px;
        color: #505050;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
    }
`;


function ManualButtonComponent({
    label,
    value,
    list,
    placeholder,
    disable,
    mode,
    required,
    openPosition,
    styleContainer,
    classContainer,
    styleDropdown,
    classDropdown,
    styleDropdownItemBox,
    classDropdownItemBox,
    onSelect,
}) {
    const [selectValue, setSelectValue] = useState([]);
    const [listItem, setListItem] = useState([]);
    const [open, setOpen] = useState(false)
    const dropdownRef = useRef(null)
    const buttonDropdownRef = useRef(null)

    useEffect(() => {
        const init = async () => {
            window.addEventListener('click', eventClickOutsideDropdown)
        };
        init();

        return () => {
            window.removeEventListener('click', eventClickOutsideDropdown)
        }
    }, [])

    useEffect(() => {
        const _list = Array.isArray(list) ? list : [];
        const _value = Array.isArray(value) ? value : [];
        setSelectValue(_value);
        setListItem(_list);
    }, [value, list])

    useEffect(() => {
    }, [list])

    useEffect(() => {
        if (open && selectValue.length > 0 && dropdownRef.current) {
            const index = listItem.findIndex(x => x.id === selectValue[0]?.id);
            if (index >= 0) {
                dropdownRef.current.scrollTo({
                    top: 50 * index,
                    behavior: "smooth",
                });
            }
        }
    }, [open])

    function eventClickOutsideDropdown(event) {
        if (dropdownRef.current
            && buttonDropdownRef.current
            && !dropdownRef.current.contains(event.target)
            && !buttonDropdownRef.current.contains(event.target)) {
            setOpen(false);
        }
    }

    function onCheckActive(param) {
        const model = selectValue?.find(x => x.id === param?.id);
        return model ? true : false;
    }
    function onCheckActiveAll() {
        return selectValue.length === listItem.length;
    }
    function handleSelect(index) {
        if (disable) return;
        let _selectValue = JSON.parse(JSON.stringify(selectValue));
        const detail = listItem[index]
        if (mode === "multi") {
            const _index = _selectValue.findIndex(x => x.id === detail.id)
            if (_index >= 0) {
                _selectValue.splice(_index, 1)
            } else {
                _selectValue.push(detail)
            }
        } else {
            _selectValue = [detail]
        }
        setSelectValue(_selectValue)
        onSelect && onSelect(_selectValue)
        if (mode === "single") {
            setOpen(false)
        }
    }
    function handleSelectAll() {
        if (disable) return;
        let _selectValue = selectValue.length === listItem.length ? [] : JSON.parse(JSON.stringify(listItem));
        setSelectValue(_selectValue)
        onSelect && onSelect(_selectValue)
    }
    function handleOpen() {
        if (disable) return;
        setOpen(!open)
    }

    return (
        <Container className={`${classContainer}`} style={{ ...styleContainer }}>
            {label &&
                <div className="label vertical-center">
                    {label}
                    {required && <div style={{ color: "#F84242", marginLeft: "2px", marginTop: "-4px" }}>*</div>}
                </div>
            }
            <DropdownBox
                className={`${classDropdown} ${open ? "open" : ""}`}
                style={{ ...styleDropdown }}
            >
                <div
                    ref={buttonDropdownRef}
                    className={`dropdown-content vertical-center ${disable ? "disabled" : ""}`}
                    onClick={handleOpen}
                >
                    <div className="label-placeholder">{placeholder || ""}</div>
                    <div className={`image-arrow-box content-center`}>
                        <img className={`image-arrow ${open ? "open" : ""}`} alt="img" src={IconArrow} />
                    </div>
                </div>
                {open &&
                    <DropdownItemBox ref={dropdownRef} className={`${classDropdownItemBox} ${openPosition === "top" ? 'box-top' : ''}`} style={{ ...styleDropdownItemBox }}>
                        {listItem.map((_value, _index) => {
                            return (
                                <div key={_index} className={`menu-${mode} vertical-center`}
                                    title={_value.label}
                                    onClick={(e) => { handleSelect(_index) }}>
                                    <div>
                                        {_value.label}
                                    </div>
                                </div>
                            )
                        })}
                        {listItem.length === 0 &&
                            <div className="nodata content-center">ไม่มีข้อมูล</div>
                        }
                    </DropdownItemBox>
                }
            </DropdownBox>
        </Container>
    )
}

export default ManualButtonComponent;